"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

var _moment = _interopRequireDefault(require("moment"));

var _status = _interopRequireDefault(require("../../../constants/status"));

require("../styles/_header.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Header = /*#__PURE__*/function (_Component) {
  _inherits(Header, _Component);

  var _super = _createSuper(Header);

  function Header() {
    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClickStage", function (index, stagesNumber) {
      var _this$props = _this.props,
          gotoOutput = _this$props.gotoOutput,
          getCurrentOutput = _this$props.getCurrentOutput,
          history = _this$props.history;
      var currentOutput = getCurrentOutput();
      var outputId = currentOutput.outputId,
          versions = currentOutput.versions,
          videoId = currentOutput.videoId,
          status = currentOutput.status;
      var selectedStageIndex = index - 1;
      var lastStage = stagesNumber - 1;
      var search = (0, _commonReact.isPublicUrl)() ? history.location.search : '';

      if (selectedStageIndex === 0) {
        return void history.rootPush({
          pathname: "/video-tool/builder/".concat(videoId),
          search: search
        });
      }

      if (selectedStageIndex === lastStage && status.name === 'APPROVED') {
        return void history.rootPush({
          pathname: "/video-tool/complete/".concat(videoId, "/").concat(outputId),
          search: search
        });
      }

      var versionToSelect = versions[selectedStageIndex - 1];

      if (!versionToSelect || !versionToSelect.versionNumber) {
        return;
      }

      gotoOutput(outputId, versionToSelect.versionNumber)();
    });

    return _this;
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          currentVersionNumber = _this$props2.currentVersionNumber,
          getCurrentOutput = _this$props2.getCurrentOutput,
          videoName = _this$props2.videoName,
          videoProjectName = _this$props2.videoProjectName,
          gotoOutput = _this$props2.gotoOutput,
          hasInternalPermission = _this$props2.hasInternalPermission,
          toggleInternalMode = _this$props2.toggleInternalMode,
          internalMode = _this$props2.internalMode;
      var output = getCurrentOutput();
      var status = output.status.name;
      var canToggleInternal = hasInternalPermission && (status === 'INTERNAL_REVIEW' || status === 'EDITING');
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "video-review-header"
      }, /*#__PURE__*/_react.default.createElement(_commonReact.CollaborationPageHeader, {
        title: "[".concat(output.readableId, "] ").concat((0, _getVideoOutputName.default)(output, videoName)),
        subtitle: "Projects",
        subtitleLink: "/video-tool",
        titleIconColor: "white",
        alwaysShowSubtitle: true,
        actionPopupBackgroundColor: "bigFat",
        titleSuffix: output.versions.length > 1 ? /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
          type: "BUTTON",
          options: output.versions.map(function (_, index) {
            return {
              label: "Version ".concat(index + 1),
              value: index + 1
            };
          }).reverse(),
          value: {
            label: "Version ".concat(currentVersionNumber)
          },
          onChange: function onChange(_ref) {
            var value = _ref.value;
            return gotoOutput(output.outputId, value);
          }
        }) : void 0,
        actionPopupOptions: [canToggleInternal ? {
          label: "".concat(internalMode ? 'Exit ' : '', " Internal Mode (c)"),
          action: toggleInternalMode
        } : void 0].filter(Boolean)
      }));
    }
  }]);

  return Header;
}(_react.Component);

exports.default = Header;